/**
 * User-visible copy for modals, buttons, and validation across the medical PA dashboard.
 *
 * Prefer importing named constants from this module instead of duplicating strings in components.
 *
 * @module stringLiterals
 */
export const DEFAULT_INSURANCE_ISSUE_TEXT = "Insurance Issue";
export const RAISE_QUERY_MODAL_TITLE = "Trigger RPA";
export const RAISE_QUERY_MODAL_SAVE_BUTTON_TEXT = "Trigger RPA";
export const RAISE_QUERY_MODAL_CANCEL_BUTTON_TEXT = "Cancel";
export const RAISE_QUERY_MODAL_RADIO_BUTTON_TEXT = "Radio Button :";
export const UNASSIGNED_TEXT = "unassigned";
export const UNASSIGNED_TEXT_LABEL = "Unassign";
export const REASSIGN_MODAL_TITLE = "Re-Assign";
export const REASSIGN_MODAL_SAVE_BUTTON_TEXT = "Save";
export const REASSIGN_MODAL_CANCEL_BUTTON_TEXT = "Cancel";
export const REASSIGN_MODAL_ASSIGNED_TO_TEXT = "This Auth is assigned to";
export const REASSIGN_MODAL_NOT_ASSIGNED_TEXT =
  "This Auth is not assigned to anyone";
export const REASSIGN_MODAL_REASSIGN_TO_TEXT = "Re-assign To";
export const REASSIGN_MODAL_SELECT_MEMBER_TEXT = "Select Member";
export const ASSIGNED_TO_PROVIDER_NAME = "assigned_to.provider_name";
export const ASSIGNED_TO_PROVIDER_ID = "assigned_to.provider_id";
export const ASSIGNED_TO_ASSIGNED_AT = "timestamps.assigned_at";
export const BULK_REASSIGN_MODAL_TITLE = "Reassign PA Orders";
export const BULK_REASSIGN_MODAL_SAVE_BUTTON_TEXT = "Save";
export const BULK_REASSIGN_MODAL_CANCEL_BUTTON_TEXT = "Close";
export const BULK_REASSIGN_MODAL_WARNING_TEXT =
  "This action will reassign the selected PA orders to the selected provider.";
export const BULK_REASSIGN_MODAL_SELECT_PROVIDER_TEXT =
  "Select a provider to reassign the PA orders to:";
export const LOADING_TEXT_FOR_BUTTON = "Updating...";
export const SAVING_TEXT_FOR_BUTTON = "Saving...";
export const SAVE_BUTTON_TEXT = "Save";
export const CANCEL_BUTTON_TEXT = "Cancel";
export const DOCUMENT_TITLE_LABEL = "Document Title (Enter as per OncoEmr)";
export const HOLD_TEXT_UNTIL = "Hold Until :";
export const LOADING_TEXT_FOR_HEALTH_CARE_FACILITIES =
  "Loading health care facilities...";
export const SELECT_A_HEALTH_CARE_FACILITY = "Select a HealthCare Facility";
export const GI_RPA_CONFIGURATION = "GI RPA Configuration";
export const GROUP_INBOX_ROUTE_RPA_LABEL = "RPA";
export const GROUP_INBOX_ROUTE_API_LABEL = "API";
export const ADD_NEW_VIEW = "Add New View";
export const ADD_NEW_VIEW_TAB_MODAL_TITLE = "Add New Configuration";
export const EDIT_VIEW_TAB_MODAL_TITLE = "Edit Configuration";
export const VIEW_CONFIGURATION_EDITOR_MODE = "view";
export const EDIT_CONFIGURATION_EDITOR_MODE = "edit";
export const CONFIGURATION_EDITOR_TITLE = "Configuration Editor";
export const ADD_NEW_VIEW_TAB_TYPE = "add";
export const EDIT_VIEW_TAB_TYPE = "edit";
export const TO_SYNC_CHANGES_IN_GI_CONFIGURATION_WITH_CHRON_JOB_CONFIGURATIONS =
  "To sync the changes in GI Configuration with the Chron Job Configurations, please reach out to Tech Team.";
export const BEARER_TOKEN_NOT_AVAILABLE = "Bearer token not available";
export const FAILED_TO_ADD_OR_EDIT_GI_CONFIGURATION =
  "Failed to add or edit GI configuration";
export const ERROR_ADDING_OR_EDITING_GI_CONFIGURATION =
  "Error adding or editing GI configuration";
export const CONFIG_CHANGED_WARNING =
  "You have made changes to the configuration. Please be cautious before saving.";
export const GI_CONFIGURATION_UPDATED_SUCCESSFULLY =
  "GI configuration updated successfully";
export const ERROR_UPDATING_GI_CONFIGURATION =
  "Error updating GI configuration";
export const SELECT_HEALTH_CARE_FACILITY_TITLE =
  "Select health care facility to add/edit configuration";
export const NO_GI_CONFIGURATIONS_FOUND = "No GI configurations found";
export const GI_CONFIGURATION_STATUS_UPDATED_SUCCESSFULLY =
  "GI configuration status updated successfully";
export const ERROR_UPDATING_GI_CONFIGURATION_STATUS =
  "Error updating GI configuration status";
export const COMMENTS_WRITEBACK_VALIDATION_MESSAGE =
  "We have observed the following information is missing in your comment please make the changes and try again.";
// export const PORTAL_ONCO_EMR = "onco_emr";
export const FRONT_END_PRIORITY_VALUE_FOR_RABBITMQ_QUEUE = 5;
export const NOT_INITIATED = "Not Initiated";
export const DOCUMENT_SCREENSHOT_VIEWER_TITLE = "Document Screenshot Viewer";
export const AUTHORISATION_DETAILS_SAVED_SUCCESSFULLY =
  "Authorisation details saved successfully";
export const FAILED_TO_SAVE_AUTHORISATION_DETAILS =
  "Failed to save authorisation details";
